<nav class="sidebar">
  <mat-nav-list>
    <a mat-list-item routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
      <mat-icon matListItemIcon>apps</mat-icon>
      <span matListItemTitle>Apps</span>
    </a>
    <a mat-list-item routerLink="/profile" routerLinkActive="active">
      <mat-icon matListItemIcon>person</mat-icon>
      <span matListItemTitle>Profile</span>
    </a>
  </mat-nav-list>
</nav>
